import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AppleCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Get the account_id from the URL
    const params = new URLSearchParams(location.search);
    const account_id = params.get('account_id');
    const error = params.get('error');

    if (error) {
      // Handle error
      console.error('Apple login error:', error);
      navigate('/login?error=apple_login_failed');
      return;
    }

    if (account_id) {
      // Redirect to the account page
      navigate(`/account/${account_id}`);
    } else {
      // Handle missing account_id
      console.error('Missing account_id in response');
      navigate('/login?error=apple_login_failed');
    }
  }, [location, navigate]);

  return (
    <div>
      <p>Processing Apple login...</p>
    </div>
  );
};

export default AppleCallback; 